/*eslint-disable no-undef */
import phina from 'phina.js'

export default ()=>{
/**
  * @class SPGuage
  * @extends phina.ui.Gauge
  */
phina.define('SPGauge', {
  superClass: 'phina.ui.Gauge',

  init: function(options) {
    var self = this;
    options = (options || {}).$safe({
    });
    this.superInit(options);
    this.text = phina.display.Label({
      text:this.value, stroke:'#000', fill:'#FFF',
      fontSize: 20, strokeWidth: 5, align: 'left', fontWeight: 'bold',
    }).addChildTo(this)
    .setSize(this.width, this.height)
    .setPosition(-this.width/2, -this.height)
    .fromJSON({ update: function(){ 
      this.text = Math.round(self.visualValue);
    }})
    this.text.tweener
      .clear()
      .wait(2000)
      .set('visible',false);

    this
    .on('change', function(){
      this.text.show()
        .tweener
          .clear()
          .wait(2000)
          .set('visible',false);
    })
  },

  // setValue: function(value) {
  //   value = Math.clamp(value, 0, this.maxValue);

  //   // end when now value equal value of argument
  //   if (this.value === value) return ;

  //   // fire value change event
  //   this.flare('change');

  //   this.oldValue = this.oldValue || this._value;
  //   this._value = value;
  //   this.text.text = value;

  //   if (this.animation) {
  //     this.tweener.ontween = function() {
  //       this._dirtyDraw = true;
  //     }.bind(this);
  //     this.visualAlpha = 1.0;
  //     this.tweener.clear()
  //       .to({'visualAlpha': 1.0}, 1000) //TODO waitしたら緑バーが動かない
  //       .to({'visualAlpha': 0.0}, 1000)
  //       .call(function() {
  //         this.oldValue=0;
  //         this.flare('changed');
  //         if (this.isEmpty()) {
  //           this.flare('empty');
  //         }
  //         else if (this.isFull()) {
  //           this.flare('full');
  //         }
  //       }, this);
  //   } else {
  //     this.visualAlpha = 0.0;
  //     this.oldValue=0;
  //     this.flare('changed');
  //     if (this.isEmpty()) {
  //       this.flare('empty');
  //     }
  //     else if (this.isFull()) {
  //       this.flare('full');
  //     }
  //   }
  // },

  // getRate: function() {
  //   var rate = this.visualValue/this.maxValue;
  //   return rate;
  // },

  // prerender: function(canvas) {
  //   canvas.roundRect(-this.width/2, -this.height/2, this.width, this.height, this.cornerRadius);
  // },

  // postrender: function(canvas) {
  //   var rate = this.getRate();
  //   canvas.context.save();
  //   // ダメージ前のゲージ
  //   canvas.context.fillStyle = this.damageColor;
  //   canvas.context.globalAlpha = this.visualAlpha;
  //   canvas.fillRect(-this.width/2, -this.height/2,
  //     this.width*this.oldValue/this.maxValue, this.height);

  //   // 実際の体力ゲージ
  //   canvas.context.fillStyle = this.gaugeColor;
  //   canvas.context.globalAlpha = 1.0;
  //   canvas.context.clip();
  //   canvas.fillRect(-this.width/2, -this.height/2,
  //      this.width*this.value/this.maxValue, this.height);
  //   canvas.context.restore();
  // },

});
}